import { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { DataView } from 'primereact/dataview';
import { addCategory, deleteCategory, fetchCategories, updateCategory } from '../../apis/home/category';
import toast, { Toaster } from 'react-hot-toast';

export default function Categories() {

    const [category, setCategory] = useState([]);
    const fileUploadRef = useRef(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [newCategory, setNewCategory] = useState({ title: '', imageUrl: '' });
    const [previewUrl, setPreviewUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [editCategory, seteditCategory] = useState(null);


    const openDialog = () => setDialogVisible(true);
    const hideDialog = () => {
        setDialogVisible(false)
        setisEdit(false);
    };

    const getCategories = async () => {

        try {
            setLoading(true);

            console.log('getting categories');

            const categories = await fetchCategories();

            console.log(categories);

            setCategory(categories);
        } catch (error) {
            console.log('31 -error - get Categories');
            // console.log(error);
            toast.error('Error: Fetching Category');

        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        getCategories();
    }, []);

    const saveCategory = async () => {

        try {

            setLoading(true);

            if (isEdit) {
                if (!editCategory.title || !editCategory.imageUrl) {
                    toast.error('Please provide both title and image!');
                    return;
                }

                await updateCategory(editCategory);
                toast.success('Category Updated');
            } else {

                if (!newCategory.title || !newCategory.image) {
                    toast.error('Please provide both title and image!');
                    return;
                }

                // console.log(newCategory);

                const formData = new FormData();
                formData.append('title', newCategory.title);
                formData.append('image', newCategory.image);

                await addCategory(newCategory, formData);

                toast.success('Category Added');
            }

            setNewCategory({ title: '', image: '' }); // clear form
            setPreviewUrl(null);
            hideDialog();
            setTimeout(() => {
                getCategories();
            }, 1000);

        } catch (error) {
            toast.error(!isEdit ? 'Error: Adding Category' : 'Error: Editing Category');
        } finally {
            setLoading(false);
        }
    };

    const uploadHandler = async ({ files }) => {
        const file = files[0];

        if (isEdit) {
            seteditCategory((prev) => ({ ...prev, image: file }));
        } else {
            setNewCategory((prev) => ({ ...prev, image: file }));
        }
        setPreviewUrl(URL.createObjectURL(file));
    };

    const onSelect = (e) => {
        console.log('starting -111- onselcet');

        const file = e.files[0];
        if (!file.type.startsWith('image/')) {
            fileUploadRef.current.clear();
            alert('Only image files are allowed!');
            return;
        }

        uploadHandler({ files: e.files }); // manually call handler
    };

    const deleteImage = () => {
        fileUploadRef.current.clear();
        if (isEdit) {
            seteditCategory((prev) => ({ ...prev, image: '' }));
        } else {
            setNewCategory((prev) => ({ ...prev, image: '' }));
        }
        setPreviewUrl(null);
    };

    const handleEdit = (item) => {
        setisEdit(true);
        setDialogVisible(true);
        seteditCategory(item);
    };

    const handleDelete = (id, url) => {
        try {
            // setLoading(true);
            deleteCategory(id, url);
            toast.success('Category Deleted');
            // setTimeout(() => {
            //     getCategories();
            // }, 1000);
            setCategory(prev => prev.filter(b => b.categoryId !== id));
        } catch (error) {
            toast.error('Error: Deleting Category');
        } finally {
            // setLoading(false);
        }
    };

    const itemTemplate = (item) => {
        return (
            <div className="p-d-flex p-ai-center p-p-3 p-mb-2 surface-100" style={{
                padding: '0.5rem', margin: '0.3rem', border: '0.5px solid green', borderRadius: '0.5rem',
                maxWidth: '160px',
            }}>
                <img
                    // src={`data:image/jpeg;base64,${item.image}`}
                    src={`${item.imageUrl}`}
                    alt={item.title}
                    style={{ width: '140px', height: '100px', objectFit: 'cover', marginRight: '0rem', borderRadius: '8px' }}
                />
                <div className="p-flex-grow-1">
                    <h5 className="p-m-0" style={{ textWrap: 'wrap' }}>{item.title}</h5>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'space-between' }}>
                    <Button icon="pi pi-pencil" className="p-button-sm p-button-text p-mr-2" onClick={() => handleEdit(item)} />
                    <Button icon="pi pi-trash" className="p-button-sm p-button-text p-button-danger" onClick={() => handleDelete(item.categoryId, item.imageUrl)} />
                </div>
            </div>
        );
    };

    return (
        <>
            <Toaster />
            <h2>Product - Categories</h2>

            <Button label="Add Category" icon="pi pi-plus" onClick={openDialog} />

            <Dialog header={isEdit ? 'Edit Category' : 'Add Category'} visible={dialogVisible} onHide={hideDialog}>
                <div className="flex flex-col gap-3">

                    {
                        isEdit ?

                            <InputText placeholder="Category Title" value={editCategory.title} onChange={(e) => seteditCategory({ ...editCategory, title: e.target.value })} />
                            :
                            <InputText placeholder="Category Title" onChange={(e) => setNewCategory({ ...newCategory, title: e.target.value })} />
                    }
                    {/* 
                    <InputText placeholder="Category Title" onChange={(e) => setNewCategory({ ...newCategory, title: e.target.value })} /> */}
                    <FileUpload ref={fileUploadRef} mode="basic" customUpload
                        onSelect={onSelect}
                        name="image" accept='image/*' chooseLabel="Upload Image" multiple='false' />
                    <Button loading={loading} label="Save" icon="pi pi-check" onClick={saveCategory} />
                </div>
                <span style={{ color: 'red' }}>Note: Only upload Square images</span>
                <div className="flex justify-center items-center mt-5 gap-8">
                    {previewUrl ?
                        <div className='flex'>
                            <img
                                src={previewUrl}
                                alt="Preview"
                                style={{ width: '200px', height: 'auto', objectFit: 'contain' }}
                            />
                            <div>
                                <Button label="Remove Image" icon="pi pi-trash" severity="danger" onClick={deleteImage} text />
                            </div>
                        </div>
                        : (
                            isEdit && editCategory.imageUrl && (

                                <img
                                    // src={`data:image/jpeg;base64,${editCategory.image}`}
                                    src={`${editCategory.imageUrl}`}
                                    alt={editCategory.title}
                                    style={{ width: '200px', height: 'auto', objectFit: 'contain', }}
                                />)

                        )

                    }
                </div>


            </Dialog>

            <div className="p-m-3 mt-4">
                <DataView value={category} layout="list" itemTemplate={itemTemplate} loading={loading} emptyMessage='No Categories Found' />
            </div>
        </>
    );
}